import React, { createRef, Component } from "react";
import {Map, WMSTileLayer,ScaleControl,Marker,GeoJSON,Popup as ReactPopup,Pane} 
from "react-leaflet";
import { Button, Message, Icon, Popup } from "semantic-ui-react";
import L from "leaflet";
import Control from "react-leaflet-control";
import axios from 'axios'
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faExpand,faWindowClose,faChartBar,faCompress,faGlobeAsia,faInfoCircle,faThList} 
from "@fortawesome/free-solid-svg-icons";
import MouseControl from "../../MousePosition";
import domain from "../../domain";
import { isNull } from "util";
import DateSlider from "./DateSlider";
import colors from "../../colors";
import urls from "../../urls";
import { FadeLoader } from "react-spinners";
import reservoir_icon from '../assets/res.png'
import { OffCanvas, OffCanvasMenu } from "react-offcanvas";
import { Menu } from "semantic-ui-react";
import moment from "moment";
import PieChart from "./PieChart";

library.add( faWindowClose,faChartBar,faExpand,faCompress,faGlobeAsia,faInfoCircle,faThList);

let count = 0;
let count1 = 0;

const crs = L.CRS.EPSG4326;
const style = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};
var label = {};
function capitalize(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

const zoomLevel = 10; 
class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
   
      minZoom: 3,
      maxZoom: 15,
      zoom: window.innerWidth > 1000 ? 4 : 3,
      layers: urls.map_layer,
      url: urls.bhuvan_map,

      baseLayers: false,
      baselayerselected: "Map",
      center: window.innerWidth > 1000 ? [22.12539, 79.00164] : [20.13, 80.58],

      pointInfo: null,
      legend: null,
      isMenuOpened: true,
      visibleRight: false,
      isExpand: false,
      showInfo: false,
      layerloading: false,
      selectedBasin: null,
      reservoirs: [], // Store the reservoir data
      selectedReservoir: null,
      basininfo: null,
      chartloading_reservoir: false,
      chartData_reservoir: null,
    };
  }
  mapRef = createRef();
  tileRef = createRef();

  resetZoom = () => {
    //console.log("reset zoom");
    const leafletMap = this.mapRef.current.leafletElement;
    leafletMap.setZoom(this.state.zoom);
    leafletMap.panTo(new L.LatLng(25.12539, 80.00164));
  };

  showInfo = () => {this.setState({ showInfo: !this.state.showInfo });
  };

  highlightIndia = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    layer.setStyle({
      weight: 1,
      color: "#0000ff",
      fillOpacity: 0,
    });

   // map.fitBounds(layer.getBounds());
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, // Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });
  };

  highlightStateBoundary = (feature, layer) => {
    const map = this.mapRef.current.leafletElement;
    ////console.log(feature.properties);
    if (feature) {
      if (feature.properties.state === "india") {
        layer.setStyle({ weight: 0, color: "#0000ff",fillOpacity: 0 });
      } else if (feature.properties.basin !== null) {
        layer.setStyle({weight: 2,color: "#800000",fillOpacity: 0});
      } else {
        layer.setStyle({weight: 1,color: "#800000", fillOpacity: 0}); 
      }
    }
    let string =
      typeof feature.properties.mandal !== "undefined" ? feature.properties.mandal
        : typeof feature.properties.district !== "undefined" ? feature.properties.district
          : typeof feature.properties.state !== "undefined" ? feature.properties.state
            : typeof feature.properties.basin !== "undefined" ? feature.properties.basin
              : null;
   // map.fitBounds(layer.getBounds());
   map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, // Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });
  
    if (label !== undefined) {
      map.removeLayer(label);
    }
    if (string === 'india')
      string = "India"
   
    if (feature.properties.state !== "india") {
      label = L.marker(layer.getBounds().getCenter(), {
        icon: L.divIcon({
          className: "label",
          html: `<h5 color='red'>${string}</h5>`,
          iconSize: [100, 40],
        }),
      }).addTo(map);
    } else if (feature.properties.basin !== null) {
      label = L.marker(layer.getBounds().getCenter(), {
        icon: L.divIcon({
          className: "label",
          html: `<h3 color='red'>${string}</h3>`,
          iconSize: [100, 60],
        }),
      }).addTo(map);
    } };

  onMouseOver = async (e) => {
    let result = await axios({
      method: "post",
      url: `${domain.DBServer}/get-pixel-boundary-status`,
      data: {lon: e.latlng.lng,lat: e.latlng.lat}
    });
    if (result) {
      if (result.data[0].bounds) {
        this.props.setLatLng(e.latlng);
        this.props.makeChartDataAvailableDays();
        if (this.props.selected !== null) {
          this.props.handleVisibleGraphPanelOnMapClick();
        } }
      else { return }
    }
  };
  componentDidUpdate(prevProps, PrevState) {
    if (this.props.selectedLayer !== prevProps.selectedLayer) {
      ////console.log("compttttttt",this.props.selected);

      let layer =
        this.props.selected !== null &&
          this.props.selected !== "Standardized Reservoir Storage Index-reservoir" &&  this.props.selected !== "Standardized Water Spread Index-State" &&  this.props.selected !== "Standardized Water Spread Index-Basin" &&  this.props.selected !== "Composite Hydrological Drought Index-chdi"
          ? this.props.selected.toLowerCase().split(" ").join("-") +
          ":" +
          this.props.selectedLayer[this.props.selected]
          : "standardized-runoff-index-annual-cumulative:20200615_zscore";
          //: "standardized-water-spread-index-basin";
         //: "Composite Hydrological Drought Index-chdi";
         //  : "composite-hydrological-drought-index-telangana";
      let wms_url =
        this.props.selected !== null &&
          this.props.selected !== "Standardized Reservoir Storage Index-reservoir" &&  this.props.selected !== "Standardized Water Spread Index-State" &&  this.props.selected !== "Standardized Water Spread Index-Basin" &&  this.props.selected !== "Composite Hydrological Drought Index-chdi"
          ? `${domain.Geoserver}/nhp_${this.props.selected
            .toLowerCase()
            .split(" ")
            .join("-")}/wms`
          //: `${domain.Geoserver}/nhp_standardized-water-spread-index/wms`;
          : `${domain.Geoserver}/nhp_standardized-runoff-index-annual-cumulative/wms`;
         //: `${domain.Geoserver}/nhp_composite-hydrological-drought-index-telangana/wms`;
      this.getLegendGraphic(wms_url, layer).then((legend) => {
        ////console.log("comeeee",legend);
        this.props.setLegend(legend); 
      });
    }

    if (this.props.visibleLeft === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
    if (this.props.visibleGraphPanel === false) {
      const leafletMap = this.mapRef.current.leafletElement;
      leafletMap.invalidateSize();
    }
  }

  async getLegendGraphic(wms_url, layer) {
    let request = "GetLegendGraphic";
    let format = "image/png";
    let width = 20;
    let height = 15;
    let legend_options = "dpi:100;bgColor:0xffffff;transparent:true";
    let img_src = `${wms_url}?request=${request}&layer=${layer}&format=${format}&width=${width}&height=${height}&legend_options=${legend_options}`;
    return img_src;
  }

  handleAnimationChangeRight = () => {
    this.setState({visibleRight: !this.state.visibleRight});
      // width: !this.state.visible?"76.5%":"100%"  
  };
  handleExpand = () => {
    this.setState({isExpand: !this.state.isExpand});
  };

  handleSRSIpoint = () => {
  if(this.props.indiaHDBasinsselected!=="#"){
  }
}
//------------TO GET SRSI TIMESERIES GRAPH ON MAP, srsichart18dec.js is the display chart code--------
// here all index values of srsi is combined in an array and stored in srsi_chart[]

addPopup = (e) => {
  ////console.log(e.target.feature.properties);
  ////console.log(this.props.selected.split("-")[1])
  this.props.emptyChartData();

  let gid = e.target.feature.properties.gid;
  ////console.log("ididididid", e.target.feature.properties.gid)

  axios.get(
    `${domain.DBServer}/get-SRSIID-data/${e.target.feature.properties.gid}`
  ).then((result) => {
    let chartData = [],
    srsi_chart=[];

    if (result) {
      if (result.data) {
        ////console.log("hqhqhq", result.data);
        let a = result.data
       // let resArr = []
       // result.data.filter(function (item) {
         // var i = resArr.findIndex(x => (x.dates == item.dates));
         // if (i <= -1)
           // resArr.push(item);
        //});
        //////console.log("ssssssss", resArr);
        let resArr = [];
        result.data.forEach(function (item) {
          // Check if the entry with the same id and date is already in resArr
          let existingEntryIndex = resArr.findIndex(
            x => x.id === item.id && x.dates === item.dates
          );
        
          if (existingEntryIndex === -1) {
            // If the entry is not in resArr, add it along with associated index
            resArr.push({
              id: item.id,
              dates: item.day,
              index: item.index // You may need to adjust this based on your data structure
            });
          } else {
            // If the entry is already in resArr, update the index (or add to an array of indices)
            // Adjust this part based on your specific requirements
            resArr[existingEntryIndex].index += item.index;
          }
        });
        ////console.log("ssssssss", resArr);
        chartData = resArr.map((result) => {
          let chartDate = moment(result.dates);
          ////console.log("ramannnn",chartDate);
          return [
            Date.UTC(
              parseInt(chartDate.format("YYYY"), 10),
              parseInt(chartDate.format("MM"), 10) - 1,
              parseInt(chartDate.format("DD"), 10)
            ),
            this.props.selected.split("-")[1] === 'day' ? Number(result.day).toFixed(3) : this.props.selected.split("-")[1] === 'id' ? Number(result.id).toFixed(3) : Number(result.index).toFixed(3),
            //this.props.selected.split("-")[1] === 'id' ? Number(result5.id).toFixed(3) : this.props.selected.split("-")[1] === 'index' ? Number(result5.index).toFixed(3)  : /* provide a default value here */ 0
          ];
        });
      }
    }
        ////console.log("noneeeeeee", chartData);
        var dates_mod = chartData.map(function (x) {
          return new Date(x[0]);
        });
        ////console.log("yuuuuuuu",dates_mod.length);
        //let date = new Date(Math.max.apply(null, dates_mod));
        
        let availableDates = result.data.map(item => Date(item.dates));
       ////console.log("shivvvvv", availableDates);
       let maximumdate = new Date(Math.max.apply(null, dates_mod));
       ////console.log("exexexe", maximumdate);
        let curr_date = maximumdate.setDate(maximumdate.getDate() - 2);
       ////console.log("mnmnmn", curr_date);
         
        let position = e.latlng;
        let name = e.target.feature.properties.name;
        //console.log("mmmmmm", name)

        if (result.data){
          srsi_chart=result.data.map((result)=>{
            return(result.dates)
 });
 //console.log(srsi_chart,"//////////res///////////")
}
        this.props.toggleVisibleGraphPanel_pie();
        this.props.setGradientContent(position, name, availableDates, chartData, srsi_chart);
      });
    };
    
//i am having 2 tables- first india-res-poindata from which res id,name,basin is coming and second tale is srsi where res id, 
//day,month and index is present, using db query i have joined both the geojson file. using geojson.io everything is correctly coming.
// i have attached file srsicolors for your reference in which i have joined both the tables.
//onpointclick function, using this id,name and basin is coming over points but day,month,year and index not
//THIS POINTCLICK IS FOR MOUSE OVER A RESERVOIR POINT BASED ON WHICH RESERVOIR INFO IS DISPLAYED
pointClick = (feature, layer) => {
  //console.log("ffffffffffffffffpoints",feature)
    // Round off the index to 2 decimal places
    const roundedIndex = parseFloat(feature.properties.index).toFixed(2);
  //const indexContent = feature.properties.index !== undefined ? `<tr><td><b>Index</b></td><td><b>${feature.properties.index}</b></td></tr>` : '';
  let popupContent =
  "<table class='table table-bordered table-sm'>" + 
  "<thead class='bg-primary text-white'><tr><th class='text-center'>Reservoir Name</th><th class='text-center'>SRSI Index</th><th class='text-center'>Basin</th><th class='text-center'>Available Index Value as on Date</th>"+
  "<tbody><tr><td><b color='blue'>" +
  feature.properties.name +
  "</b></td><td> <b color='blue'> " +
 // feature.properties.gid +
  //"</b></td><td> <b color='blue'> " +
  roundedIndex +
  "</b></td><td> <b color='blue'> " +
  feature.properties.basin +
  "</b></td><td>" +
  (feature.properties.day && feature.properties.month && feature.properties.year
    ? `${feature.properties.day}-${feature.properties.month}-${feature.properties.year}`
    : 'Date not available') +
  
  "</b></td></tr></tbody></table>";

     layer.bindPopup(popupContent);
  layer.on({
    mouseover: (e) => {
      layer.openPopup();
    },
    mouseout: (e) => {
      layer.closePopup();
    },
    click: this.addPopup,
  });
};

pointToLayer = (feature, latlng) => {
  const { index } = feature.properties;
  let color;
  
 if (index <= -2) {
  color = 'red';
} else if (index >= -2 && index < -1.5) {
  color = '#f59154';
} else if (index >= -1.5 && index < -1) {
  color = '#feb669'; 
} else if (index >= -1 && index < 0) {
  color = '#fed38c';
} else if (index >= 0 && index < 1) {
  color = '#f0f9ba';
} else if (index >= 1 && index < 1.5) {
  color = '#b3e0a7';
} else if (index >= 1.5 && index < 2) {
  color = '#59a4b2';
} else if (index >= 2) {
  color = 'blue';
} else {
  color = 'grey'; // Default color
}
  return L.circleMarker(latlng, {
    radius: 5,
    fillColor: color,
    color: '#000',
    weight: 1,
    opacity: 1,
    fillOpacity: 0.8,
  });
};

//=======================================================================
//=====================================================================
//pointToLayer = (feature, latlng) => {
  //const circleMarker = pointToLayer(feature, latlng);
//circleMarker.addTo(map); 

  //const color = 'red'; 
  //return L.circleMarker(latlng, {
    //radius: 8, 
    //fillColor: color,
    //color: '#000', 
    //weight: 1, 
    //opacity: 1,
   // fillOpacity: 0.8,
 // });
//};
//================================================================================================
highlightSRSIBasin = (feature, layer) => {
  const map = this.mapRef.current.leafletElement;
 //console.log("ffffffffffffffffeaturessbasin",feature)
  //console.log(map);
  layer.setStyle({
    weight: 0,
    color: "#FFFFFf",
    fillOpacity: 0,
  });
 // map.fitBounds(layer.getBounds(),{maxZoom:5});

  map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25,
    maxZoom:5 // Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });
};

highlightSRSIReservoir = (feature, layer) => {
  const map = this.mapRef.current.leafletElement;
  //console.log("ffffffffffffffffeaturessrsireservoir",feature)
  //console.log(feature)
  //console.log(map);
  layer.setStyle({
    weight: 0,
    color: "#FFFFFf",
    fillOpacity: 0,
  });
 // map.fitBounds(layer.getBounds(),{maxZoom:9});
 map.flyToBounds(layer.getBounds(), {
  animate: true, // Enables animation
  duration: 1,   // Duration in seconds (adjust as needed)
  easeLinearity: 0.25,
  maxZoom:9, // Controls easing (default is 0.25, lower makes it smoother)
//  padding: [50, 50] // Adds some padding around the bounds
});
};

highlightSWSIBasin = (feature, layer) => {
  const map = this.mapRef.current.leafletElement;
 //console.log("ffffffffffffffffeaturesswsibasin",feature)
  //console.log(map);
  layer.setStyle({
    weight: 0,
    color: "#FFFFFf",
    fillOpacity: 0,
  });
  //map.fitBounds(layer.getBounds(),{maxZoom:5});
  map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, // Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });
};

highlightSWSISubbasin = (feature, layer) => {
  const map = this.mapRef.current.leafletElement;
  //console.log("ffffffffffffffffeaturesswsisubbbasin",feature)
  //console.log(feature)
  //console.log(map);
  layer.setStyle({
    weight: 0,
    color: "#FFFFFf",
    fillOpacity: 0,
  });
  //map.fitBounds(layer.getBounds(),{maxZoom:9});
  map.flyToBounds(layer.getBounds(), {
    animate: true, // Enables animation
    duration: 1,   // Duration in seconds (adjust as needed)
    easeLinearity: 0.25, // Controls easing (default is 0.25, lower makes it smoother)
  //  padding: [50, 50] // Adds some padding around the bounds
  });
};
//===========================================================================================================
//============================================================================================================
  loading = (e) => { this.setState({layerloading: true})};
  load = (e) => {this.setState({ layerloading: false})};

  displayBaseLayers = () => {
    //console.log("base layers");
    this.setState({ baseLayers: !this.state.baseLayers});   
  };

  findActiveLayers = () => {
    const leafletMap = this.mapRef.current.leafletElement;
    let layers = leafletMap._layers;
    Object.keys(layers).map((key) => {
      let layer = layers[key];
      Object.keys(layer).map((key) => {
        //console.log(layer[key]);
        return true;
      });
      return true;
    });
  };

  changeBaseLayer = (event) => {
    let layers, url;
    this.findActiveLayers();
    //console.log(event.target);
    if (event.target.value === "Map") {
      url = urls.bhuvan_map;
      layers = urls.map_layer;
    } else if (event.target.value === "Satellite") {
      layers = urls.s_layer;
      // url='http://192.168.192.103:8080/geoserver/cite/wms'
      url = urls.satellite;
    }
    this.setState({ baselayerselected: event.target.value, url: url,  layers: layers});
  };

  highlightState = (feature, layer) => {
    // const map = this.mapRef.current.leafletElement
    layer.setStyle({
      weight: 2,
      color: "#000000",
      fillOpacity: 0,
      // fill:false
    });

    layer.on({
      mouseover: (event) => {
        layer.setStyle({ weight: 3,color: "#0000ff",fillOpacity: 0 });
      },
      mouseout: (event) => {
        layer.setStyle({ weight: 3, color: "#000000", fillOpacity: 0 });
          //  fill:false
      },
    });
  };

  render() {
    let test,chdidate,dateObj;
   
   
   // console.log("chdidate",this.props.activeDate)
   // console.log("graphicalHD",this.props.visibleGraphPanel ,this.props.chartData,this.props.rchartData )
    dateObj=new Date(this.props.activeDate);
    chdidate=`${dateObj.getFullYear()}${(dateObj.getMonth() + 1).toString().padStart(2, '0')}`;
console.log("chdidate1",chdidate)
    delete L.Icon.Default.prototype._getIconUrl;
    //console.log(this.props.srsibasinboundary,"aaaaasrsibasinboundary");
    //console.log("selectttttttttttttttt",this.props.selected)
    //console.log(this.props.srsireservoirboundary,"aaaaaasrsireservoirboundary");

    //console.log(this.state.popup);
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
   
    let table_info_sri = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "F4C2C2" }}
          >
           <b> Interpretation of Index</b>{" "}
          </th></tr>
          
        <tr>
          {" "}
          <td> = 2.00</td><td> Extremely Wet</td></tr>
        <tr><td> 1.50 to 1.99</td><td> Severely Wet</td> </tr>
        <tr> <td> 1.00 to 1.49</td> <td> Moderately Wet </td></tr>
        <tr> <td> -0.99 to 0.99</td><td> Normal</td></tr>
        <tr> <td>-1.49 to -1.00 </td><td> Moderately Dry</td></tr>
        <tr> <td>-1.99 to -1.49 </td> <td> Severely Dry</td></tr>
        <tr><td> &lt;= -2.00 </td><td> Extremely Dry</td></tr>
      </table>
    );
    let table_info_sri_t = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "gray" }}
          >
          <b> Interpretation of Index</b>{" "}
          </th>
        </tr>
        <tr>
          {" "}
          <td> = 2.00</td><td> Extremely rise</td></tr>
        <tr><td> 1.50 to 1.99</td><td> High rise</td></tr>
        <tr><td> 1.00 to 1.49</td> <td> Moderate rise </td></tr>
        <tr> <td> -0.99 to 0.99</td><td> Normal</td></tr>
        <tr><td>-1.49 to -1.00 </td><td> Moderate fall</td></tr>
        <tr><td>-1.99 to -1.49 </td><td> Severe fall</td></tr>
        <tr><td> &lt;= -2.00 </td><td> Extreme fall</td></tr>
      </table>
    );
    let table_info_srsi = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "gray" }}
          >
            <b> Interpretation of Index</b>{" "}
          </th>
        </tr>
        <tr>
          {" "}
          <td> = 2.00</td><td> Extreme rise</td></tr>
         <tr><td> 1.50 to 1.99</td><td> Severely rise</td></tr>
        <tr><td> 1.00 to 1.49</td><td> Moderately rise </td></tr>
        <tr><td> -0.99 to 0.99</td><td> Normal</td></tr>
        <tr><td>-1.49 to -1.00 </td><td> Moderately fall</td> </tr>
        <tr><td>-1.99 to -1.49 </td>  <td> Severely fall</td></tr>
        <tr> <td> &lt;= -2.00 </td> <td> Extremely fall</td>  </tr>
      </table>
    );
    
    let table_info_swsi_basin = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "gray" }}
          >
            <b> Interpretation of Index</b>{" "}
          </th>
        </tr>
        <tr>
          {" "}
          <td> = 2.00</td><td> Extremely Wet</td> </tr>
        <tr><td> 1.50 to 1.99</td><td> Severely Wet</td></tr>
        <tr> <td> 1.00 to 1.49</td> <td> Moderately Wet </td></tr>
        <tr><td> -0.99 to 0.99</td><td> Normal</td></tr>
        <tr><td>-1.49 to -1.00 </td><td> Moderately Dry</td></tr>
        <tr><td>-1.99 to -1.49 </td><td> Severely Dry</td></tr>
        <tr><td> &lt;= -2.00 </td><td> Extremely Dry</td></tr>
      </table>
    );
    let table_info_swsi_state = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "gray" }}
          >
            <b> Interpretation of Index</b>{" "}
          </th>
        </tr>
        <tr>
          {" "}
          <td> = 2.00</td><td> Extremely Wet</td> </tr>
        <tr><td> 1.50 to 1.99</td><td> Severely Wet</td></tr>
        <tr> <td> 1.00 to 1.49</td> <td> Moderately Wet </td></tr>
        <tr><td> -0.99 to 0.99</td><td> Normal</td></tr>
        <tr><td>-1.49 to -1.00 </td><td> Moderately Dry</td></tr>
        <tr><td>-1.99 to -1.49 </td><td> Severely Dry</td></tr>
        <tr><td> &lt;= -2.00 </td><td> Extremely Dry</td></tr>
      </table>
    );
    
    let table_info_chdi = (
      <table className="table-bordered">
        <tr><th colspan="2"
            style={{ textAlign: "center", backgroundColor: "gray" }}
          >
           <b> Interpretation of Index</b>{" "}
          </th>
        </tr>
        <tr>
          {" "}
          <td> = 2.00</td> <td> Extremely rise</td> </tr>
        <tr> <td> 1.50 to 1.99</td>  <td> Severely rise</td>  </tr>
        <tr><td> 1.00 to 1.49</td><td> Moderately rise </td></tr>
        <tr> <td> -0.99 to 0.99</td> <td> Normal</td></tr>
        <tr> <td>-1.49 to -1.00 </td><td> Moderately fall</td> </tr>
        <tr>  <td>-1.99 to -1.49 </td>  <td> Severely fall</td>  </tr>
        <tr>  <td> &lt;= -2.00 </td> <td> Extremely fall</td> </tr>
      </table>
    );

    if (this.props.selectedLayer[this.props.selected]) {
      test = this.props.selected;
      //console.log(test,"testchddddddddddddddddd")
      if (test === "Standardized Reservoir Storage Index-reservoir") {
      }
    }

    //console.log(this.props.stateBoundary);
    return (
      <Map
        ref={this.mapRef}
        center={this.state.center}
        minZoom={this.state.minZoom}
        maxZoom={this.state.maxZoom}
        zoom={this.state.zoom}
        onclick={
          this.props.selected !==
            "Standardized Reservoir Storage Index-reservoir"
            ? this.onMouseOver
            : null
        }
        // onlayeradd={this.onLayer}
        style={{ backgroundColor: "#fff" }}
        attributionControl={false}
        crs={crs}
        dragging={true}
      >   
        {this.props.india_states_boundary !== null ?
          <GeoJSON
            ref="geojson"
            key={this.props.india_states_boundary.features[0].id}
            data={this.props.india_states_boundary}
            onEachFeature={this.highlightState}
          />
          : null}
        {this.props.stateBoundary !== null ? (
          <Pane className="GridcellsPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.stateBoundary.features[0].id}
              data={this.props.stateBoundary}
              onEachFeature={this.highlightStateBoundary}
              crs={crs}
              zIndex={3}
            />
          </Pane>
        ) : null}
{/*==================================================NEWLY CREATED BOUNDARY GEOJSON SRSI POINT FILE============================================*/}
{this.props.SRSIPoint !== null && this.props.selected === "Standardized Reservoir Storage Index-reservoir" ? (
  <Pane className="GeoJSONPane">-
    {" "}
    <GeoJSON
      ref="geojson"
      key={this.props.SRSIPoint.features[0].id}
      data={this.props.SRSIPoint}
      pointToLayer={this.pointToLayer}
      onEachFeature={this.pointClick}
      crs={crs}
    />
  </Pane>
) : null}
 {/*==================================================NEWLY CREATED BOUNDARY GEOJSON SRSI============================================*/}

 {this.props.srsibasinboundary !== null ? (
          <Pane className="GeoJSONPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.srsibasinboundary.features[0].id}
              data={this.props.srsibasinboundary}
              pointToLayer={this.pointToLayer}
              onEachFeature={this.highlightSRSIBasin}
              crs={crs}
            />
          </Pane>
        ) : null}

{this.props.srsireservoirboundary !== null ? (
          <Pane className="GeoJSONPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.srsireservoirboundary.features[0].id}
              data={this.props.srsireservoirboundary}
              pointToLayer={this.pointToLayer}
              onEachFeature={this.highlightSRSIReservoir}
              crs={crs}
            />
          </Pane>
        ) : null}

{this.props.swsibasinboundary !== null ? (
          <Pane className="GeoJSONPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.swsibasinboundary.features[0].id}
              data={this.props.swsibasinboundary}
              //pointToLayer={this.pointToLayer}
              onEachFeature={this.highlightSWSIBasin}
              crs={crs}
            />
          </Pane>
        ) : null}

{this.props.swsisubbasinboundary !== null ? (
          <Pane className="GeoJSONPane">
            {" "}
            <GeoJSON
              ref="geojson"
              key={this.props.swsisubbasinboundary.features[0].id}
              data={this.props.swsisubbasinboundary}
              //pointToLayer={this.pointToLayer}
              onEachFeature={this.highlightSWSISubbasin}
              crs={crs}
            />
          </Pane>
        ) : null}
        
        {this.state.baselayerselected !== null ? (
          <WMSTileLayer
            ref={this.tileRef}
            layers={this.state.layers}
            // url='http://192.168.192.103:8080/geoserver/cite/wms'
            url={this.state.url}
            format="image/png"
            transparent={true}
            // crs={ crs}
            zIndex={1}
            onloading={this.loading}
            onload={this.load}
          />
        ) : null}
{/*==============================you created to display tif file over map for chdi- 2 november 2023==================================================*/}
       
{/*https://bhuvan.nrsc.gov.in/nhpgs/nhp_composite-hydrological-drought-index-telangana/wms?request=GetLegendGraphic&layer=composite-hydrological-drought-index-chdi:JANUARY-GAUSSIAN_201301-PROBABILITY&
format=image/png&width=20&height=15&legend_options=dpi:100;bgColor:0xffffff;transparent:true*/} 
     
 {this.props.selected === "Composite Hydrological Drought Index-chdi" ? (
            <WMSTileLayer
              url={`${domain.Geoserver}/nhp_composite-hydrological-drought-index-telangana/wms`}
              //layers="nhp_composite-hydrological-drought-index-telangana:nhp_hd_composite_index"
              //layers="composite-hydrological-drought-index-chdi:sri_styles"
              layers={`composite-hydrological-drought-index-telangana:NHP_ISRO_CHDI_${chdidate}`}
              //layers="composite-hydrological-drought-index-telangana:JANUARY-GAUSSIAN_201201-PROBABILITY,JANUARY-GAUSSIAN_201301-PROBABILITY,JANUARY-GAUSSIAN_201401-PROBABILITY"
              format="image/png"
              zIndex={10}
              transparent={true}
              onloading={this.loading}
              onload={this.load}
              tiled={false}
            />
          ) : null}
  {
  function getLayerName(selected) {
    // Implement logic to map your selected value to the corresponding layer name
    // For example, if selected is "Standardized Water Spread Index-State", return "swsi_jan2023_grid_aw"
    // You can add more cases for other layer names
    switch (selected) {
        case "Standardized Water Spread Index-State":
            return "swsi_jan2023_grid_aw";
        // Add more cases as needed
        default:
            return ""; // Return a default layer name or handle it as needed
    }
}}
          {this.props.selected === "Standardized Water Spread Index-Basin" ? (
    (() => {
      //console.log("dtttttt",this.props.activeDate)
      //console.log("dtttttttttttsplit",(this.props.activeDate).split("-"))
        let date = (this.props.activeDate).split("-");
        let newdate=date[1]+date[2]
        //console.log("dtttttttt",newdate)
        return (
            <WMSTileLayer
                url={`${domain.Geoserver}/nhp_standardized-water-spread-index/wms`}
                layers={`nhp_standardized-water-spread-index:swsi_${newdate}_grid_aw`}
                format="image/png"
                zIndex={10}
                transparent={true}
                onloading={this.loading}
                onload={this.load}
                tiled={false}
            />
        );
    })()
) : null}


{this.props.selected === "Standardized Water Spread Index-State" ? (
    (() => {
      //console.log("dtttttt",this.props.activeDate)
      //console.log("dtttttttttttsplit",(this.props.activeDate).split("-"))
        let date = (this.props.activeDate).split("-");
        let newdate=date[1]+date[2]
        //console.log("dtttttttt",newdate)
        return (
            <WMSTileLayer
                url={`${domain.Geoserver}/nhp_standardized-water-spread-index/wms`}
                layers={`nhp_standardized-water-spread-index:swsi_${newdate}_grid_aw`}
                format="image/png"
                zIndex={10}
                transparent={true}
                onloading={this.loading}
                onload={this.load}
                tiled={false}
            />
        );
    })()
) : null}       
 {/* ====================================================================you created to display tif file over map for chdi- 2 november 2023========================================================================*/}
        {this.props.selected !== null && this.props.selected !=="Standardized Reservoir Storage Index-reservoir" ? (
            <WMSTileLayer
              url={`${
                domain.Geoserver
                }/nhp_${this.props.selected
                  .toLowerCase()
                  .split(" ")
                  .join("-")}/wms`}
              layers={
                "nhp_" +
                this.props.selected.toLowerCase().split(" ").join("-") +
                ":" +
                this.props.selectedLayer[this.props.selected]
              }
              format="image/png"
              zIndex={5}
              transparent={true}
              onloading={this.loading}
              onload={this.load}
            // opacity={1}
            // crs={ crs}
            />
          ) : null}
        {this.props.stateBoundary === null ? this.resetZoom : null}
       
        {this.props.latlng !== null ? (
          <Marker
            position={
              this.props.latlng.lat && this.props.latlng.lng
                ? [this.props.latlng.lat, this.props.latlng.lng]
                : [0, 0]
            }
          />
        ) : null}

        <Control position="topleft">
          <Popup
            trigger={
              <Button
                size="tiny"
                onClick={this.resetZoom}
                compact
                style={{ padding: "8px" }}
              >
                <FontAwesomeIcon icon="globe-asia" size="lg" />
              </Button>
            }
            position="right center"
          >
            <Popup.Content>Reset Zoom</Popup.Content>
          </Popup>
        </Control>
        {this.state.layerloading || this.props.datesloading ? (
          <Control position="topleft">
            <div style={style}>
              <FadeLoader
                height="15"
                radius="3"
                margin="3"
                width="10"
                // css={override}
                sizeUnit={"px"}
                // size={150}
                color={"#123abc"}
                loading={this.state.layerloading}
              />
            </div>
          </Control>
        ) : null}
        <Control position="topleft">
          <div>
            {this.props.showInfo ? (
              <div
                style={{
                  marginRight: "0px",
                  paddingLeft: "0rem",
                  paddingRight: "0rem",
                  marginLeft: "0px",
                }}
              >
                <Button
                  basic
                  attached="right"
                  floated="right"
                  size="tiny"
                  compact
                  style={{ padding: "5px" }}
                  onClick={this.props.showPointInfo}
                  color={isNull(this.props.pointInfo) ? "brown" : "teal"}
                >
                  <FontAwesomeIcon icon="window-close" size="lg" />
                </Button>
                <Message
                  icon="map marker alternate"
                  info
                  warning={isNull(this.props.pointInfo)}
                  attached="bottom"
                >
                  <Icon name="map marker alternate" />
                  {this.props.pointInfo !== null ? (
                    <Message.Content>
                      <Message.Header>{this.props.selected}</Message.Header>
                      <b>Date:</b>&nbsp;{this.props.activeDate}
                      <br />
                      {isNull(this.props.pointInfo) ? (
                        <div> <b>Data not available in this region</b></div>
                      ) : (
                          <div><b>Value:</b>&nbsp;{this.props.pointInfo}{" "}
                          </div>
                        )}
                      <b></b>
                      {/* <b>State:</b>&nbsp;{this.props.stateInfo.geojson.properties.STATE.toLowerCase().split(' ').map((word)=> word.replace(word[0], word[0].toUpperCase())).join(' ')} */}
                    </Message.Content>
                  ) : ("Select a place within Indian boundary")}
                </Message>
              </div>
            ) : (
                <Popup
                  trigger={
                    <Button
                      size="tiny"
                      compact
                      style={{ padding: "8px" }}
                      onClick={this.showInfo}
                    >
                      <FontAwesomeIcon icon="info-circle" size="lg" />
                    </Button>
                  }
                  position="right center"
                >
                  <Popup.Content>
                    click this to know about what is in the point you clicked in
                    the map
                </Popup.Content>
                </Popup>
              )}
          </div>
        </Control>
        {window.innerWidth > 1000 ?
          <Control position="topleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.sidebar, marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control> :
          <Control position="bottomleft">
            <Button
              onClick={this.props.handleAnimationChange}
              secondary
              style={{ backgroundColor: colors.graphical , marginLeft: "-10px" }}
              attached="right"
              compact
              size="mini"
            >
              <FontAwesomeIcon icon="th-list" size="sm" />
            </Button>
          </Control>
        }

        {!this.props.visibleGraphPanel && 
        (this.props.chartData !== null|| this.props.rchartData!==null )? (
          <Control position="bottomright">
            <Popup trigger={
                <Button
                  onClick={this.props.toggleVisibleGraphPanel}
                  secondary
                  style={{ backgroundColor: colors.graphical  }}
                  compact
                  size="medium"
                >
                <FontAwesomeIcon icon="chart-bar" size="lg" />
                </Button>
              }
              position="left center"
            >
              <Popup.Content>Graphical Analysis</Popup.Content>
            </Popup>
          </Control>
        ) : null}

        <Control position="topright">
          <OffCanvas
            width={300}
            transitionDuration={300}
            effect={"overlay"}
            style={{ cursor: "move" }}
            isMenuOpened={this.state.isMenuOpened}
            position={"right"}
          >
            <OffCanvasMenu
              style={{
                alignContent: "center",
                backgroundColor: "rgb(255,255,255)",
                borderColor: "blue",
                top: "50px",
                marginRight: "10px",
              }}
            >
              <div>
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.displayBaseLayers}
                    style={{ textAlign: "center", marginLeft: `5px` }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.black,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Base Layers
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.state.baseLayers ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>
                {this.state.baseLayers ? (
                  <div>
                    <input
                      type="radio"
                      name="baselayer"
                      value="Satellite"
                      checked={this.state.baselayerselected === "Satellite"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Satellite <br />
                    <input
                      type="radio"
                      name="baselayer"
                      value="Map"
                      checked={this.state.baselayerselected === "Map"}
                      onChange={this.changeBaseLayer}
                    />{" "}
                    Map
                  </div>
                ) : null}

                <div></div>
                <div style={{ background: colors["final_side"] }}>
                  <Menu.Item
                    as="div"
                    onClick={this.props.displayLegend}
                    style={{ textAlign: "center", marginLeft: `5px` }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          width: "80%",
                          color: colors.black,
                          fontSize: "small",
                          cursor: "default",
                        }}
                      >
                        Legend
                      </div>
                      <div
                        style={{
                          textAlign: "right",
                          width: "20%",
                          marginRight: "10px",
                        }}
                      >
                        {this.props.legendVisible ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                            <FontAwesomeIcon icon="angle-right" />
                          )}
                      </div>
                    </div>
                  </Menu.Item>
                </div>

                {this.props.legendVisible ? (
                  <React.Fragment>
                    {/* <center style={{ backgroundColor: colors.final_side_sub}}> */}
                      <center>
                      {test ===
                        "Standardized Runoff Index-Annual Cumulative" ? (
                          <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                            Annual Cumulative SRI <br />{" "}
                            
                            {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                              "DD MMM YYYY"
                            )}{" "}
                          </p>
                        ) : test ===
                          "Standardized Runoff Index-30 Day Cumulative" ? (
                            <p style={{ fontSize: '1rem',fontWeight:' 600'}}>
                              30 Day Cumulative SRI <br />{" "}
                              {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                "DD MMM YYYY"
                              )}{" "}
                            </p>
                          ) : test ===
                            "Standardized Runoff Index-60 Day Cumulative" ? (
                              <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                                60 Day Cumulative SRI <br />{" "}
                                {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                  "DD MMM YYYY"
                                )}{" "}
                              </p>
                            ) : test ===
                              "Standardized Runoff Index-90 Day Cumulative" ? (
                                <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                                  90 Day Cumulative Standardized Runoff Index <br />{" "}
                                  {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                    "DD MMM YYYY"
                                  )}{" "}
                                </p>
                              ) : test ===
                                "Standardized Runoff Index-180 Day Cumulative" ? (
                                  <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                                    180 Day Cumulative Standardized Runoff Index <br />{" "}
                                    {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                      "DD MMM YYYY"
                                    )}{" "}
                                  </p>
                                ) : test ===
                                  "Standardized Runoff Index-365 Day Cumulative" ? (
                                    <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                                      365 Day Cumulative Standardized Runoff Index <br />{" "}
                                      {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                        "DD MMM YYYY"
                                      )}{" "}
                                    </p>

                                  ) : test ===
                                    "Standardized Groundwater Level Index-Telangana" ? (
                                      <p style={{ fontSize: '1rem',fontWeight:' 600' }}>
                                        Telangana Standardized Groundwater Level Index <br />{" "}
                                        {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                          "DD MMM YYYY"
                                        )}{" "}
                                      </p>
                                    
                                      ): test ===
                                      "Standardized Water Spread Index-Basin" ?(
                                        <p style={{ fontSize: '1rem',fontWeight:' 600'}}>
                                          Standardized Water Spread Index <br />{""}
                                        
                                          {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                            "DD MMM YYYY"
                                            )}{" "}
                                        </p>
                                         ): test ===
                                         "Standardized Water Spread Index-State" ?(
                                           <p style={{ fontSize: '1rem',fontWeight:' 600'}}>
                                             Standardized Water Spread Index <br />{""}
                                           
                                             {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                               "DD MMM YYYY"
                                               )}{" "}
                                           </p>
                                      ): test ===
                                      "Composite Hydrological Drought Index-chdi"?(
                                        <p style={{ fontSize: '1rem',fontWeight:' 600'}}>
                                          Composite Hydrological Drought Index <br />{""}
                                         
                                          {moment(this.props.activeDate, "DD-MMM-YYYY").format(
                                            "DD MMM YYYY"
                                            )}{" "}
                                        </p>
                                      ): this.props.selected==='Standardized Reservoir Storage Index-reservoir'? 
                                      <p style={{fontSize: '1rem',fontWeight:' 600'}}> Standardized Reservoir Storage Index <br/>  
                                      
                                      {moment(this.props.activeDate,"DD-MMM-YYYY").format("DD MMM YYYY")}  
                                      </p>:null
}
                    </center>
                    <div  style={{
                 // backgroundColor: colors.final_side_sub,
                  height: '35vh',
                  minHeight: '35vh',
                  overflowY: 'auto',
                  width: '100%',
                  boxSizing: 'border-box',
                  padding: '5px',
                  scrollPaddingBottom: '5px',
                  //marginTop: '20px', // Adjust this if you need spacing from the top
              }}>
                      <table style={{ margin: "auto" }}>
                        <tr>
                          <td>                           
                                <img src={this.props.legend} alt="" />
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            {(test ==="Standardized Runoff Index-Annual Cumulative" || test ==="Standardized Runoff Index-30 Day Cumulative" ||test ==="Standardized Runoff Index-60 Day Cumulative" ||test ==="Standardized Runoff Index-90 Day Cumulative" ||test ==="Standardized Runoff Index-180 Day Cumulative"||test ==="Standardized Runoff Index-365 Day Cumulative")
                              ? table_info_sri
                              : test ==="Standardized Groundwater Level Index-Telangana"
                                ? table_info_sri_t
                                 : test ==="Standardized Water Spread Index-Basin"
                                  ? table_info_swsi_basin
                                  : test ==="Standardized Water Spread Index-State"
                                  ? table_info_swsi_state
                                  : test ==="Composite Hydrological Drought Index-chdi"
                                  ? table_info_chdi
                                  : this.props.selected ==="Standardized Reservoir Storage Index-reservoir"
                                  ? table_info_srsi
                                  : null}
                          </td>               
                        </tr>
                      </table>
                    </div>
                  </React.Fragment>
                ) : null}
              </div>
              <div></div>
              <div style={{ background: colors["final_side"] }}>
                <Menu.Item
                  as="div"
                  onClick={this.props.sri_stats !== null? this.props.toggleVisibleGraphPanel_pie: null}
                  style={{ textAlign: "center", marginLeft: `5px` }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      style={{
                        width: "80%",
                        color: colors.black,
                        fontSize: "small",
                        cursor: "default",
                      }}
                    >
                      Graph
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        width: "20%",
                        marginRight: "10px",
                       
                      }}
                    >
                      {this.props.visibleGraphPanel_pie && this.props.sri_stats !== null  ? (
                          <FontAwesomeIcon icon="angle-down" />
                        ) : (
                          <FontAwesomeIcon icon="angle-right" />
                        )}
                    </div>
                  </div>
                </Menu.Item>
              </div>

              {this.props.visibleGraphPanel_pie && this.props.sri_stats ? (
               <div style={{
              //  backgroundColor: colors.final_side_sub,
                height: '25vh',
                minHeight: '25vh',
                overflowY: 'auto',
                width: '100%',
                boxSizing: 'border-box',
                padding: '5px',
                scrollPaddingBottom: '5px',
                //marginTop: '20px', // Adjust this if you need spacing from the top
            }}>
                  <p style={{ fontSize: '1rem',fontWeight:' 600'}}>
                    {" "}
                    Selected Region : {this.props.selectedRegion}
                  </p>
                  <PieChart
                    series={this.props.sri_stats}
                    menu={this.props.selected}
                    pie_categories={this.props.pie_categories}
                  />
                </div>
              ) : null}

            </OffCanvasMenu>
          </OffCanvas>
        </Control>

        <Control position="bottomleft" style={{ pointerEvents: "auto", cursor: "auto" }}>
          <DateSlider {...this.props.sliderOptions} />
        </Control>
        <MouseControl position="bottomleft"/>
        <ScaleControl metric={true} />

        {this.props.popup !== null ? (
          this.props.popup.position !== null && !this.props.nodata ? (
            <ReactPopup
              key={`popup-${this.props.popup.key_p}`}
              position={this.props.popup.position}
              className="request-popup"
            >
              <Message.Content
                style={{ backgroundColor: colors.white, color: colors.black }} >
              <table class='table table-bordered table-sm'>
    
                    <tr class='bg-primary'>
                        <td>Reservoir Name</td>
                        <td><b>{capitalize(this.props.popup.name)}</b></td>
                    </tr>
                    <tr>
                        <td><b>Index</b></td>
                        <td>{Number(this.props.popup.index).toFixed(2)}</td>
                    </tr>
                </table>
              </Message.Content>
            </ReactPopup>
          ) : null
        ) : null}

        {this.props.popup !== null ? (
          this.props.popup.position !== null && this.props.nodata ? (
            <ReactPopup
              key={`popup-${this.props.popup.key_p}`}
              position={this.props.popup.position}
              className="request-popup"
            >
              <div > 
              <table class='table table-bordered table-sm'>
              <tr>
                  <td>Reservoir Name</td>
                  <td class="font-weight-bold">{capitalize(this.props.popup.name)}</td>
              </tr>
          </table>

              </div>
            </ReactPopup>
          ) : null
        ) : null}
      </Map>
    );
  }
}

export default MapView;